import { render } from "./Favorite.vue?vue&type=template&id=11a2c1ce&scoped=true"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"

import "./Favorite.vue?vue&type=style&index=0&id=11a2c1ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11a2c1ce"

export default script